import { Component, OnInit, Input, ViewEncapsulation, Inject, PLATFORM_ID, AfterViewInit, ChangeDetectorRef, OnDestroy, ChangeDetectionStrategy } from "@angular/core";
import { ComponentRendering } from "@sitecore-jss/sitecore-jss-angular";
import { ILinkItemDataModel } from "../../models/link-item.datamodel";
import { ImageService } from "../../services/image.service";
import { JssStylingService } from '../../jss-styling.service';
import { ThemeService } from "../../services/theme.service";
import { isPlatformServer } from "@angular/common";
import { JssContextService } from '../../jss-context.service';
import { Subscription } from 'rxjs';

@Component({
    selector: "app-help",
    templateUrl: "./help.component.html",
    styleUrls: ["./help.component.scss"],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HelpComponent implements OnInit, AfterViewInit, OnDestroy {
    @Input() rendering: ComponentRendering;
    _isPlatformServer: boolean = false;
    links: ILinkItemDataModel[] = [];
    public fields: any;
    public svgCode: string;
    public wizard: string;
    public image: any;
    dynamicClass: string;
    public energySave: boolean = false;
    public energySubscription: Subscription;
    energySaveMode : boolean;
    hasChatty : boolean = false;
    public contextSubscription: Subscription;
    language:string;

    constructor(
        private imageService: ImageService,public jssContext: JssContextService, public jssStylingService: JssStylingService, private themeService: ThemeService, private cdr: ChangeDetectorRef , @Inject(PLATFORM_ID) public readonly platformId: string
    ) {platformId;}

    ngOnInit() {
      
        this._isPlatformServer = isPlatformServer(this.platformId);
        this.wizard = (this.rendering.fields?.WizardVariation as any)?.value;
        this.contextSubscription = this.jssContext.state.subscribe((newState) => {
          this.language = newState.language
        });
        this.dynamicClass = this.jssStylingService.getComponentClass(this.rendering);
        this.fields = this.rendering?.fields as any;
        this.energySubscription = this.themeService.isEnegySaveModeEnabled().subscribe(energySave => {
            this.energySaveMode = energySave;
            this.image = this.imageService.getImage(this.fields);
            this.cdr.detectChanges();
            // if((this.rendering.fields?.RightImage as any)?.value){
            // }else{
            //     this.svgCode = this.imageService.getSvg(this.fields);
            // }

          });
        // if (this.fields?.Image?.value?.svgCode) {
        //     this.svgCode = this.imageService.getSvg(this.fields);
        // }
        (this.rendering.fields?.Links as []).forEach((link) => {
            this.links.push({
                href: link["fields"]["Link"]["value"]["href"],
                target: link["fields"]["Link"]["value"]["target"],
                text: link["fields"]["Link"]["value"]["text"],
            });
        });

    }

    ngAfterViewInit() {
    
        // if(!this._isPlatformServer && (this.rendering.fields?.hasWizard as any)?.value){
        if(!this._isPlatformServer){
          setTimeout(() => {
            this.hasChatty = document.querySelector('.'+ this.wizard) != null;
            this.cdr.detectChanges();
          }, 0);
          
        }
      }

    ngOnDestroy(): void {
        if (this.energySubscription){
          this.energySubscription.unsubscribe();
        }
        if (this.contextSubscription) {
          this.contextSubscription.unsubscribe();
        }
  
    }

    openChatty(event : Event) {
        event.preventDefault();
        if (!this._isPlatformServer && this.hasChatty) {
          
            let chatty = document.querySelector('.'+ this.wizard);
            if(chatty){
              chatty.classList.add("pb-chatty--open");
              document
                  .querySelector<HTMLElement>("body")
                  .classList.add("pb-overflow-y-hidden");
            }
        }
    }

}
